//#region src/schema/helpers/schema-keyboard-nav.ts
var e = (e) => [...e.querySelectorAll("[data-schema-toggle]")].filter((e) => e.offsetParent !== null && !e.closest("[hidden]")), t = (e) => e.closest(".property-children")?.closest(".property--tree")?.querySelector(":scope > [data-schema-toggle]") ?? null, n = (e) => e.closest(".property--tree")?.querySelector(":scope > .property-children [data-schema-toggle]") ?? null, r = (r) => {
	let i = r.target;
	if (r.defaultPrevented || !(i instanceof HTMLElement) || !i.hasAttribute("data-schema-toggle") || r.altKey || r.ctrlKey || r.metaKey || r.shiftKey) return;
	let a = r.currentTarget instanceof HTMLElement ? r.currentTarget : null;
	if (!a) return;
	let o = e(a), s = o.indexOf(i);
	if (s === -1) return;
	let c = i.getAttribute("aria-expanded") === "true";
	switch (r.key) {
		case "ArrowDown":
			o[s + 1]?.focus();
			break;
		case "ArrowUp":
			o[s - 1]?.focus();
			break;
		case "ArrowRight":
			c ? n(i)?.focus() : i.click();
			break;
		case "ArrowLeft":
			c ? i.click() : t(i)?.focus();
			break;
		case "Home":
			o[0]?.focus();
			break;
		case "End":
			o[o.length - 1]?.focus();
			break;
		default: return;
	}
	r.preventDefault();
};
//#endregion
export { r as handleTreeKeydown };

//# sourceMappingURL=schema-keyboard-nav.js.map